import React, { useEffect } from "react";
import AppHeader from "../../components/header";
import FAQs from "../../components/sections/FAQs/FAQs";
import Footer from "../../components/footer";
import "./style.scss";

const FAQScreen = () => {
  // Block body on purpose: a concise arrow hands React whatever the expression
  // evaluates to, and React only accepts `undefined` or a cleanup function.
  // `window.scroll` normally returns undefined, but third-party scripts (GTM
  // scroll-depth triggers, extensions) can wrap it and return something else —
  // React then tries to call that value as the cleanup and throws
  // "destroy is not a function" on unmount, e.g. when switching language.
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div className="main-wrapper faq-page">
      <AppHeader />
      <main className="body-wrapper">
        <div style={{ marginTop: "3%" }}>
          <FAQs />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default FAQScreen;
